import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {kicker && (
          <p className="flex items-center gap-2 font-label text-xs font-bold uppercase tracking-[0.24em] text-accent-700">
            <span className="h-px w-6 bg-accent-500" />
            {kicker}
          </p>
        )}
        <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">{description}</p>
        )}
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-2 md:gap-3">
        {children}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors whitespace-nowrap hover:border-primary-300 hover:text-primary-700"
          >
            {actionLabel}
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        )}
      </div>
    </div>
  );
}